var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundsms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.500038,
    y: 0.577674,
    width: 20.0769,
    height: 20.0769,
    rx: 10.0385,
    fill: "#FEFEFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.500038,
    y: 0.577674,
    width: 20.0769,
    height: 20.0769,
    rx: 10.0385,
    stroke: "#64696C",
    strokeWidth: 0.692308
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.90159 5.59957C6.32716 5.26011 6.85571 5.07581 7.40009 5.07708L7.40089 5.07708H8.97C9.48685 5.07715 9.98993 5.24402 10.4044 5.55286C10.8188 5.86172 11.1225 6.29607 11.2703 6.79136C11.325 6.97455 11.5178 7.07873 11.701 7.02406C11.8842 6.96938 11.9884 6.77656 11.9337 6.59337C11.7433 5.95527 11.352 5.39566 10.818 4.99775C10.2841 4.59983 9.63599 4.38485 8.97008 4.38477H7.40128C6.69963 4.38324 6.0184 4.62082 5.46988 5.05836C4.92125 5.49599 4.53814 6.10752 4.38374 6.79212C4.22933 7.47672 4.31285 8.19349 4.62051 8.82425C4.89545 9.38791 5.33471 9.8528 5.87788 10.1592V12.5767C5.87788 12.7167 5.96221 12.8429 6.09156 12.8965C6.22091 12.95 6.3698 12.9204 6.4688 12.8214L8.03795 11.2523C8.17313 11.1171 8.17313 10.8979 8.03795 10.7628C7.90276 10.6276 7.68359 10.6276 7.54841 10.7628L6.57018 11.741V9.94887C6.57018 9.81497 6.49296 9.69307 6.37189 9.63588C5.87967 9.40335 5.4814 9.01002 5.24275 8.52075C5.00409 8.03147 4.93931 7.47547 5.05908 6.94444C5.17885 6.4134 5.47602 5.93904 5.90159 5.59957ZM12.1083 8.30765C11.2882 8.30765 10.5017 8.63343 9.92185 9.21332C9.34195 9.79321 9.01617 10.5797 9.01617 11.3998C9.01617 12.2199 9.34195 13.0064 9.92185 13.5863C10.5017 14.1662 11.2882 14.492 12.1083 14.492H12.3572L14.6096 16.7443C14.7086 16.8433 14.8575 16.8729 14.9868 16.8193C15.1162 16.7658 15.2005 16.6395 15.2005 16.4995V14.0821C15.6419 13.8329 16.0161 13.4783 16.289 13.0484C16.6018 12.5556 16.7685 11.9842 16.7696 11.4005C16.7696 10.5804 16.4439 9.79321 15.864 9.21332C15.2841 8.63343 14.4976 8.30765 13.6775 8.30765H12.1083ZM10.4114 9.70285C10.8614 9.25279 11.4719 8.99995 12.1083 8.99995H13.6775C14.314 8.99995 14.9244 9.25279 15.3744 9.70285C15.8244 10.1528 16.0772 10.7631 16.0773 11.3995C16.0764 11.8521 15.9471 12.2952 15.7045 12.6774C15.4618 13.0597 15.1158 13.3653 14.7064 13.5588C14.5854 13.616 14.5082 13.7379 14.5082 13.8717V15.6639L12.7454 13.901C12.6805 13.8361 12.5924 13.7997 12.5006 13.7997H12.1083C11.4719 13.7997 10.8614 13.5468 10.4114 13.0968C9.96132 12.6467 9.70848 12.0363 9.70848 11.3998C9.70848 10.7633 9.96132 10.1529 10.4114 9.70285Z",
    fill: "#171717"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundsms);
export default __webpack_public_path__ + "static/media/Roundsms.7509134ea955e316db29559959f03346.svg";
export { ForwardRef as ReactComponent };